import React from "react";

const NotFound = () => {
  return (
    <div className="d-flex w-100 align-items-center justify-content-center">
      <h2>Not Found</h2>
    </div>
  );
};

export default NotFound;
